import React from "react";
import PropTypes from "prop-types";
import { List, Card, Icon, Button, message } from "antd";
import { Map } from "immutable";
import { AddressRecord, AssociateRecord } from "records/company-record";
import AddAssociateForm from "forms/add-associate-form";
import { APPLICANT_FIELDS } from "constants/form-fields";
import { PermissionContextManager } from "hocs";
import shortID from "uuid/v4";
import { LoaderSkeleton } from "../../components";
import { SaveProxy, proxyWrapper } from "utilities/save-proxy";
import { STATE_STATUS, UI_PERMISSIONS } from "constants";

const ListItem = List.Item;


const proxy = new SaveProxy();
const ProxiedButton = proxyWrapper(
    props => (
        <Button type="link" onClick={props.onClick} >
            {props.label}
        </Button>
    ),
    {
        count: false
    },
    proxy
);

class AssociatesAddTable extends React.Component {
    baseID = shortID();
    allAddresses = [];
    state = {
        status: this.props.status,
        associates:
            this.props.associates && this.props.associates.size
                ? this.props.associates
                : this.props.ASSOCIATES_EDIT ? new Map({
                    [this.baseID]: new AssociateRecord({
                        type: 1,
                        is_active: true
                    })
                }) : new Map({}),
        
        removedAssociates: new Map({}),
        addresses:
            this.props.addresses && this.props.addresses.size
                ? this.props.addresses
                : new Map({ [this.baseID]: new AddressRecord({is_active: true}) }),
        permanentAddresses:
                this.props.addresses && this.props.addresses.size
                    ? this.props.addresses
                    : new Map({ [this.baseID]: new AddressRecord({is_active: true}) }),
        permanentAddressCheck : false,
        checkBoxTableID: null,
        associateCreatedFlag: false
    };

    formRefs =
        this.props.associates && this.props.associates.size
            ? this.props.associates.map(() => React.createRef())
            : new Map({ [this.baseID]: React.createRef() });

    componentDidMount() {
        this.formRefs.map((value, key) => proxy.attach(key));
    }
    LABEL_LIST = () => {
        let APPLICANT_FIELDS_UPDATED = APPLICANT_FIELDS;
        if(this.props.recreditViewOnlyPermission === true){
            APPLICANT_FIELDS_UPDATED = APPLICANT_FIELDS?.filter((field,fieldName) => {
                return fieldName !== "remove";
            });
        }
        return(
            <List className={"f-grow-1 tabled-list tabled-list-header"} bordered>
                {APPLICANT_FIELDS_UPDATED?.map(_ => (
                    <ListItem className={"form-field-list-item"} key={_.placeholder} style={{display:"flex"}}>
                        {_.placeholder}
                    </ListItem>
                )).toList()}
            </List>
        );};

    componentDidUpdate(prevProps) {
        if ((this.props.status !== this.state.status) || (this.props.associates.size !== prevProps.associates.size)) {
            this.formRefs =
                this.props.associates && this.props.associates.size
                    ? this.props.associates.map(() => React.createRef())
                    : new Map({ [this.baseID]: React.createRef() });
            this.setState({
                status: this.props.status,
                associates: [
                    STATE_STATUS.FETCHED,
                    STATE_STATUS.UPDATED
                ].includes(this.props.status)
                    ? this.props.associates && this.props.associates.size
                        ? this.props.associates
                        : new Map({ [this.baseID]: new AssociateRecord({is_active: true}) })
                    : this.state.associates,
                addresses: [
                    STATE_STATUS.FETCHED,
                    STATE_STATUS.UPDATED
                ].includes(this.props.status)
                    ? this.props.addresses && this.props.addresses.size
                        ? this.props.addresses
                        : new Map({ [this.baseID]: new AddressRecord({is_active: true}) })
                    : this.state.addresses,
                permanentAddresses: [
                    STATE_STATUS.FETCHED,
                    STATE_STATUS.UPDATED
                ].includes(this.props.status)
                    ? this.props.addresses && this.props.addresses.size
                        ? this.props.addresses
                        : new Map({ [this.baseID]: new AddressRecord({is_active: true}) })
                    : this.state.permanentAddresses
            });
        }
    }

    /**
     * Add a new Associate form
     */
    addAssociate = type => {
        const id = shortID();
        this.formRefs = this.formRefs.set(id, React.createRef());
        proxy.attach(id);
        this.setState({
            associates: this.state.associates.set(
                id,
                new AssociateRecord({
                    type,
                    is_active: true
                })
            ),
            addresses: this.state.addresses.set(id, new AddressRecord({is_active: true})),
            associateCreatedFlag:true
        });
    };

    /**
     * Handles form state
     */
    saveFormState = (associateID, changedValues) => {
        let associateRecord =
            this.state.associates.get(associateID) ||
            this.state.associates.get(String(associateID));
        let residenceAddress =  this.state.addresses.find(
            _ => _.associate === associateID && _.address_type === 5
        );

        let permanentAddress =  this.state.permanentAddresses.find(
            _ => _.associate === associateID && _.address_type === 6
        );
        let addressRecord =
            residenceAddress || new AddressRecord({is_active: true});
            
        let permanentAddressRecord = 
            permanentAddress || new AddressRecord({is_active: true});
        var id;
        if (changedValues.residence_address) {
            if(addressRecord.getIn(["id"])){
                addressRecord = addressRecord.merge({
                    company: this.props.companyId,
                    associate: associateID,
                    ...changedValues.residence_address
                });
            } else{
                id = `${associateID}${changedValues.residence_address?.address_type}R`;
                addressRecord = addressRecord.merge({
                    company: this.props.companyId,
                    id: id,
                    associate: associateID,
                    ...changedValues.residence_address
                });
            }
            
        }
        if (changedValues.permanent_address) {
            if(permanentAddressRecord.getIn(["id"])){
                permanentAddressRecord = permanentAddressRecord.merge({
                    company: this.props.companyId,
                    associate: associateID,
                    ...changedValues.permanent_address
                });
            } else{
                id = `${associateID}${changedValues.permanent_address?.address_type}R`;
                permanentAddressRecord = permanentAddressRecord.merge({
                    company: this.props.companyId,
                    associate: associateID,
                    id: id,
                    ...changedValues.permanent_address
                });
            }
        }
        const { name, ...restValues } = changedValues;
        associateRecord = associateRecord.merge({
            company: this.props.companyId,
            ...restValues
        });
        if (name) {
            associateRecord = associateRecord.merge({
                ...name
            });
        }
        this.setState(
            {
                associates: this.state.associates
                    .set(associateID, associateRecord),
                addresses: this.state.addresses.set(addressRecord.getIn(["id"]), addressRecord),
                permanentAddresses: this.state.permanentAddresses.set(permanentAddressRecord.getIn(["id"]), permanentAddressRecord)
            },
            () => {
                if (this.props.ASSOCIATES_EDIT) {
                    proxy.activate(proxy, associateID);
                }
            }
        );
    };

    /**
     * Handles all submit
     */

    saveAllAssociates = () => {
        const errs = [];
        this.formRefs.map(_ =>
            _.current && _.current.validateFields(err => {
                if (err) {
                    errs.push(err);
                }
            })
        );

        if (errs.length === 0) {
            this.addresses = new Map({});
            this.permanentAddresses = new Map({});
            this.associates = new Map({});
            Promise.all(
                this.formRefs.map(
                    (_, associateID) =>
                        new Promise((resolve, reject) =>
                            _.current && _.current.validateFields(
                                (
                                    err,
                                    {
                                        name,
                                        residence_address,
                                        permanent_address,
                                        ...restValues
                                    }
                                ) => {
                                    if (!err) {
                                        const associateRecord = this.state.associates.get(
                                            associateID
                                        );
                                        this.associates = this.associates.set(
                                            associateID,
                                            associateRecord.merge({
                                                company: this.props.companyId,
                                                // type: type || 1,
                                                ...name,
                                                ...restValues
                                            })
                                        );
                                        this.setState({associateCreatedFlag :false});
                                        if (associateRecord) {
                                            let residenceAddress =  this.state.addresses.find(
                                                _ => _.associate === associateID && _.address_type === 5
                                            );
                                            let permanentAddress = this.state.permanentAddresses.find(
                                                _ => _.associate === associateID && _.address_type === 6
                                            );
                                            if(this.state.permanentAddressCheck && this.state.checkBoxTableID === associateID && permanentAddress) {
                                                let PA = this.state.permanentAddresses.find(
                                                    _ => _.associate === associateID && _.address_type === 6
                                                );
                                                const {id , address_type} = PA;
                                                let RA = this.state.addresses.find(
                                                    _ => _.associate === associateID && _.address_type === 5
                                                ).set("id" , id).set("address_type" , address_type);
                                                permanentAddress = RA;
                                            }
                                            else if(this.state.permanentAddressCheck && this.state.checkBoxTableID === associateID && permanent_address === undefined){
                                                let RA = residence_address.set("id" , null).set("address_type" , 6);
                                                permanentAddress = RA;
                                            }
                                            else{
                                                permanentAddress = this.state.permanentAddresses.find(
                                                    _ => _.associate === associateID && _.address_type === 6
                                                );
                                            } 
                                            this.setState({permanentAddressCheck:false});
                                            const addressRecord =
                                                residenceAddress || new AddressRecord({is_active: true});

                                            const permanentAddressRecord =
                                                permanentAddress || new AddressRecord({is_active: true});
                                            if(permanentAddress){
                                                this.addresses = this.addresses.set(
                                                    associateID,
                                                    addressRecord.merge({
                                                        associate:
                                                            associateRecord.id,
                                                        company: this.props
                                                            .companyId,
                                                        ...residence_address
                                                    })
                                                ).set(
                                                    `${associateID}${2}`,
                                                    permanentAddressRecord.merge({
                                                        associate:
                                                            associateRecord.id,
                                                        company: this.props
                                                            .companyId,
                                                        ...permanent_address,
                                                    })
                                                );
                                            } else {
                                                this.addresses = this.addresses.set(
                                                    associateID,
                                                    addressRecord.merge({
                                                        associate:
                                                            associateRecord.id,
                                                        company: this.props
                                                            .companyId,
                                                        ...residence_address
                                                    })
                                                );
                                            }
                                        }

                                        resolve(true);
                                    }
                                    reject();
                                }
                            )
                        )
                )
            )
                .then(() =>{
                    let newAddr = new Map({});
                    this.addresses.map((item, index) => {
                        if(!item.getIn(["address_line_1"])){
                            this.addresses = this.addresses.delete(index);
                        } 
                    });
                    newAddr = this.addresses.map((item) => {
                        let type="R";
                        if(item.getIn(["address_type"])==6)
                            type="P";
                        let tempId = `${item.getIn(["associate"])}${item.getIn(["address_type"])}${type}`;
                        if(item.getIn(["id"]) == tempId )
                        {
                            return item.update((add) => {
                                return add.set("id", null);
                            });
                        }
                        return item;           
                    });
                    if(this.associates && Object.values(this.associates.toJS()).map(el=>el?.shareholding).reduce((a, b) => Number(a) + Number(b), 0) > 100){
                        message.error("Shareholding sum should be less than 100");
                        return;
                    }
                    this.props.update(
                        this.props.companyId,
                        this.associates.toList().toArray(),
                        newAddr.toList().toArray(),
                        this.props.caseId,
                        ""
                    );   
                })
                .catch(() => null);
        }
    };
    /**
     * Handles form submit for each Associate
     */
    saveAssociate = (associateID, associateRecord, addressRecord, permanentAddressRecord) => {
        this.props.update(
            this.props.companyId,
            this.props.associates.set(associateID, associateRecord),
            this.props.addresses.set(addressRecord.getIn(["id"]), addressRecord).set(permanentAddressRecord.getIn(["id"]), permanentAddressRecord),
            this.props.caseId
        );
    };
    /**
     * Deletes associates for form submit
     */
    deleteAssociate = associateID => {
        // associate refers to associateID in the address record
        this.setState(
            {
                associates: this.state.associates.filter(
                    (_, associate) => associate !== associateID
                ),
                addresses: this.state.addresses.filter(
                    (_, associate) => associate !== associateID
                )
            },
            () => proxy.detach(associateID)
        );
    };

    deleteAssociateFromList = (associateID, associate) => {
        const address = this.state.addresses && this.state.addresses.find(_ => _.associate === associateID);
        this.setState({
            associates: this.state.associates
                .setIn([associateID, "is_active"], false),
            addresses: address ? 
                this.state.addresses
                    .setIn([address.id, "is_active"], false) : 
                this.state.addresses
        }, () => {    
            this.props.update(
                this.props.companyId,
                this.state.associates.toList().toArray(),
                [],
                this.props.caseId,
                "delete",
                associate
            );
        });
    }

    isLoading = () => {
        return (
            [
                STATE_STATUS.UNFETCHED,
                STATE_STATUS.FETCHING,
                STATE_STATUS.UPDATING
            ].includes(this.state.status) || !this.state.status
        );
    };

    proxiedButton = (
        <div className={"d-flex"}>
            {/* <Button type={"link"} className={"mr-5"} onClick={this.props.openCaseApplicantModal}>
                {"Select Case Applicants"}
            </Button> */}
            <ProxiedButton
                key={"proxied-save-action"}
                onClick={this.saveAllAssociates}
                label={"Save"}
            />
        </div>
    );
    getCardActions = () =>
        this.props.ASSOCIATES_EDIT && this.props.isUserAllowedToEdit
            ? [
                <a
                    key="add-associate"
                    onClick={this.addAssociate.bind(null, 1)}
                    className="mr-5"
                    disabled={!this.props.ASSOCIATES_EDIT}
                >
                    {" "}
                    <Icon type={"plus"} /> Add Associate
                </a>,
                <a
                    key="add-guarantor"
                    onClick={this.addAssociate.bind(null, 2)}
                    className="mr-5"
                    disabled={!this.props.ASSOCIATES_EDIT}
                >
                    {" "}
                    <Icon type={"plus"} /> Add Guarantor
                </a>
            ]
            : [];
    getCardExtra = () => 
        this.props.ASSOCIATES_EDIT && this.props.isUserAllowedToEdit && !this.props.recreditViewOnlyPermission ?
            [this.proxiedButton] 
            : [];
    // getCardExtra = () => [this.proxiedButton];
    
    getFormValues(associate, associateID) {

        const residence_address = this.state.addresses.find(
            _ => _.associate === associateID && _.address_type === 5
        );
        let permanent_address;
        // (residence_address && this.state.permanentAddressCheck && this.state.checkBoxTableID===associateID)
        //  ? permanent_address = this.state.addresses.find( _ => _.associate === associateID && _.address_type === 5):
        permanent_address = this.state.permanentAddresses.find(
            _ => _.associate === associateID && _.address_type === 6
        );
        if(this.state.permanentAddressCheck && this.state.checkBoxTableID === associateID && permanent_address) {
            let PA = this.state.permanentAddresses.find(
                _ => _.associate === associateID && _.address_type === 6
            );
            const {id , address_type} = PA;
            const RA = residence_address.set("id" , id).set("address_type" , address_type);
            permanent_address = RA;
        }
        else if(this.state.permanentAddressCheck && this.state.checkBoxTableID === associateID && typeof permanent_address === "undefined"){
            let RA = residence_address && residence_address.set("id" , null).set("address_type" , 6);
            permanent_address = RA;
        }
        else{
            permanent_address = this.state.permanentAddresses.find(
                _ => _.associate === associateID && _.address_type === 6
            );
        }  
        if (this.props.ASSOCIATES_EDIT) {
            return associate
                .toSeq()
                .toMap()
                .set(
                    "is_main_borrower",
                    associate.is_main_borrower
                )
                .set("name", associate.nameValue)
                .set("residence_address", residence_address)
                .set("permanent_address", permanent_address);
        }
        return associate.toDisplayForm(
            residence_address ? residence_address.formatted_string : "--",
            permanent_address ? permanent_address.formatted_string : "--"
        );
    }

    sameAddressEventListener = (associateID, checked) => {
        this.setState({permanentAddressCheck: checked, checkBoxTableID: associateID});
    }
    
    render() {
        let associateKeys = Object.keys(this.state.associates
            .filter(_ => _.is_active).toJS());
        return (
            <LoaderSkeleton loading={this.isLoading()}>
                <Card
                    className={"padless-card"}
                    title={"Applicants"}
                    extra={this.getCardExtra()}
                    actions={this.getCardActions()}
                >
                    <div className={"d-flex tabled-list-container"}>
                        {this.LABEL_LIST()}
                        {this.state.associates
                            .filter(_ => _.is_active)
                            .map((_, associateID) => (
                                <AddAssociateForm
                                    company={this.props.company}
                                    associateKeys={associateKeys}
                                    associateCreatedFlag={this.state.associateCreatedFlag}
                                    sameAddressEventListener={this.sameAddressEventListener.bind(null,associateID)}
                                    key={associateID}
                                    showSpocOnly={this.props.showSpocOnly}
                                    values={this.getFormValues(_, associateID)}
                                    associateID={associateID}
                                    onFormSubmit={this.saveAssociate.bind(
                                        null,
                                        associateID
                                    )}
                                    deleteAssociate={this.deleteAssociate.bind(
                                        null,
                                        associateID
                                    )}
                                    deleteAssociateFromList={this.deleteAssociateFromList.bind(
                                        null,
                                        associateID,
                                        _
                                    )}
                                    // onValuesChange={proxy.activate.bind(
                                    //     proxy,
                                    //     associateID
                                    // )}
                                    onValuesChange={this.saveFormState.bind(
                                        null,
                                        associateID
                                    )}
                                    ref={this.formRefs.get(associateID)}
                                    editable={this.props.ASSOCIATES_EDIT}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                    caseId={this.props.caseId}
                                />
                            ))
                            .toList()}
                    </div>
                </Card>
            </LoaderSkeleton>
        );
    }
}

AssociatesAddTable.propTypes = {
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    associates: PropTypes.object,
    addresses: PropTypes.object,
    company: PropTypes.object,
    status: PropTypes.string,
    update: PropTypes.func,
    showSpocOnly: PropTypes.bool,
    ASSOCIATES_EDIT: PropTypes.boolean,
    isUserAllowedToEdit: PropTypes.bool,
    openCaseApplicantModal: PropTypes.func,
    deleteAssociateStatus: PropTypes.string,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default PermissionContextManager({
    permission: UI_PERMISSIONS.ASSOCIATES_VIEW,
    propsPermissions: {
        ASSOCIATES_EDIT: UI_PERMISSIONS.ASSOCIATES_EDIT
    }
})(AssociatesAddTable);